<app-navbar-style-two></app-navbar-style-two>

<section class="brands-hero">
  <div class="container-fluid">
    <h1 class="text-white">Brands that earned<br />consumers’ trust</h1>
  </div>
</section>

<section class="brands-section">
  <div class="container-fluid">

    <div class="brand-row" *ngFor="let brand of brands; let i = index" [class.reverse]="i % 2 !== 0">

      <!-- TEXT -->
      <div class="brand-content px-5">
        <img class="brand-logo" [src]="brand.logo" [alt]="brand.name" />
        <h3 class="brand-category">
          <ng-container *ngFor="let cat of brand.category_slug.split(','); let last = last">

            <a [routerLink]="['/brands', brand.slug, cat.trim()]">
              {{ cat.trim() | titlecase }}
            </a>

            <span *ngIf="!last">, </span>

          </ng-container>
        </h3>
        <p>{{ brand.description }}</p>
        <a [routerLink]="['/brands', brand.slug]" class="default-btn">View Products</a>
      </div>

      <!-- IMAGE + BACKGROUND -->
      <div class="brand-visual" [class.left]="i % 2 === 0" [class.right]="i % 2 !== 0">
        <img class="brand-product" [src]="brand.image" [alt]="brand.name" />
      </div>

    </div>

  </div>
</section>


<app-footer-style-one></app-footer-style-one>